import { Component, OnDestroy, OnInit, Optional } from '@angular/core';
import { PageBase } from 'src/app/pages';

import { NavigationStart } from '@angular/router';
import { Device } from '@capacitor/device';
import { Subscription } from 'rxjs';

import { SplashScreen } from '@capacitor/splash-screen';
import { IonRouterOutlet } from '@ionic/angular';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { NotificationsService } from './services/defaults';

export let browserRefresh = false;

declare global {
  interface Window {
    ReactNativeWebView?: {
      postMessage: (message: string) => void;
    };
  }
}

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent extends PageBase implements OnInit, OnDestroy  {
  subscription: Subscription;
  public routerHidden: boolean = true;

  constructor(
    public notificationsService: NotificationsService,
    @Optional() private routerOutlet?: IonRouterOutlet,
  ) {
    super();

    this.initializeApp();
  }

  ngOnInit(): void {
    this.subscribe();
  }

  ionViewWillLeave() {
    this.subscribe();
  }

  subscribe() {
    this.subscription = this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        browserRefresh = !this.router.navigated;
      }
    });
  }

  initializeApp() {
    this.platform.ready().then(async () => {
      await SplashScreen.hide();

      if (Capacitor.getPlatform() !== 'web') {
        // Set App version as globalvar._version
        const info = await App.getInfo();
        this.globalvar._version = info.version;
      }

      this.authService.user('get');
      setTimeout(() => {
        this.routerHidden = false;
      }, 5500);

      this.languageService.setInitialAppLanguage();

      this.platform.backButton.subscribeWithPriority(10, () => {
      });

      this.authService.authState.subscribe(state => {
        if (state) {
          this.notificationsService.initPush();
          this.syncExpoPushToken();
          if (this.globalvar._appHasOnboarding) {
            this.authService.onboardingState.subscribe(state => {
              let returnTo = !this.globalvar._user.completed_onboarding ? '/tabs/profile' : '/tabs/home';

              state ? this.navCtrl.navigateRoot([this.globalvar.notificationRoute != '' ? this.globalvar.notificationRoute : returnTo], { replaceUrl: true }) : this.navCtrl.navigateRoot(['/tabs/onboarding'], { replaceUrl: true });
            });
          } else if (this.globalvar.notificationRoute) {
            this.navCtrl.navigateRoot([this.globalvar.notificationRoute], { replaceUrl: true });
          } else {
            this.navCtrl.navigateRoot(['/tabs/home'], { replaceUrl: true });
          }
        } else {
          let route = this.globalvar._appHasAuthOverview ? '/auth-overview' : '/login';
          this.navCtrl.navigateRoot([route], { replaceUrl: true });
        }
      });
    });

    this.platform.pause.subscribe(() => {
    });

    this.platform.resume.subscribe(() => {
      // TODO on resume, reload page? for the notification counter
      this.authService.authState.subscribe(async (state) => {
        if (state) {
          this.notificationsService.initPush();
          // this.notificationsService.getAllNotifications();
        } else {
          let route = this.globalvar._appHasAuthOverview ? '/auth-overview' : '/login';
          this.navCtrl.navigateRoot([route], { replaceUrl: true });
        }
      });
    });
  }

  private async syncExpoPushToken() {
    if (!window.ReactNativeWebView || !this.globalvar._user?.id) {
      return;
    }

    const token = this.globalvar._token || await this.storageService.get(this.globalvar._userToken);

    if (!token) {
      return;
    }

    window.ReactNativeWebView.postMessage(JSON.stringify({
      type: 'PASSIE_AUTH_READY',
      userId: this.globalvar._user.id,
      authToken: token,
      apiUrl: this.globalvar._apiUrl,
    }));
  }

  logDeviceInfo = async () => {
    const info = await Device.getInfo();
  };

  logBatteryInfo = async () => {
    const info = await Device.getBatteryInfo();
  };

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
